export default "__VITE_ASSET__8ecd4918__"